import { DataListState, INITIAL_DATA_LIST_STATE } from '../data-list.state';
import { ReducerStateFactory } from '../state-factory.reducer';
import { ReleaseNotes } from './release-notes.actions';

export interface ReleaseNotesInterface {}

export interface ReleaseNotesState extends DataListState<ReleaseNotesInterface> {
  entities: { [id: string]: ReleaseNote };
}

// RssResponse and RssItem represent the RSS feed parsed using Xml2Js within the effects.
// This data is fed into the ReleaseNote class for validation & cleanliness.
export interface RssResponse {
  rss: {
    $: any;
    channel: [
      {
        title: Array<string>;
        description: Array<string>;
        link: Array<string>;
        image: [
          {
            link: Array<string>;
            title: Array<string>;
            url: Array<string>;
          }
        ];
        item: Array<RssItem>;
      }
    ];
  };
}

export interface RssItem {
  title: Array<string>;
  description: Array<string>;
  link: Array<string>;
  guid: [
    {
      _: string;
      $: any;
    }
  ];
  pubDate: Array<string>;
  'content:encoded': string;
}

export class ReleaseNote {
  constructor(
    public title: string,
    public description: string,
    public guid: string,
    public link: string,
    public pubDate: string,
    public content: string,
    public valid: boolean
  ) {}

  static fromRssItem(rssItem: RssItem): ReleaseNote {
    if (this.isValid(rssItem)) {
      return new ReleaseNote(
        rssItem.title[0],
        rssItem.description[0],
        rssItem.guid[0]._,
        rssItem.link[0],
        rssItem.pubDate[0],
        rssItem['content:encoded'],
        true
      );
    }
    return null;
  }

  static isValid(rssItem: RssItem): boolean {
    return (
      !!rssItem.title &&
      !!rssItem.description &&
      !!rssItem.guid &&
      !!rssItem.pubDate &&
      !!rssItem.link &&
      !!rssItem['content:encoded']
    );
  }
}

export class ReleaseNotesReducer extends ReducerStateFactory<ReleaseNotesInterface> {
  initialState: ReleaseNotesState = {
    ...INITIAL_DATA_LIST_STATE,
  };

  protected allReducer(state: ReleaseNotesState, action): ReleaseNotesState {
    switch (action.type) {
      case ReleaseNotes.REQUEST_RETRIEVE_ALL:
        return {
          ...state,
          error: null,
          loadingAll: true,
        };
      case ReleaseNotes.RESPONSE_SUCCESS_RETRIEVE_ALL: {
        return {
          ...state,
          loadingAll: false,
          entities:
            action.payload?.rss?.channel[0]?.item?.reduce((prev, next) => {
              const feedItem = ReleaseNote.fromRssItem(next);
              return { ...prev, [feedItem.guid]: feedItem };
            }, {}) ?? {},
          ids:
            action.payload?.rss?.channel[0]?.item.map((rssItem: RssItem) => rssItem.guid[0]._) ??
            [],
        };
      }
      case ReleaseNotes.RESPONSE_FAIL_RETRIEVE_ALL: {
        return {
          ...state,
          loadingAll: false,
          error: action.payload,
        };
      }
    }

    return super.allReducer(state, action) as ReleaseNotesState;
  }
}

export const state = new ReleaseNotesReducer(ReleaseNotes);

export function reducer(...args) {
  return state.reducer.apply(state, args);
}
